/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Completeaccountsetup2Inputs */

const en_completeaccountsetup2 = /** @type {(inputs: Completeaccountsetup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete account setup`)
};

const de_completeaccountsetup2 = /** @type {(inputs: Completeaccountsetup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-Einrichtung abschließen`)
};

/**
* | output |
* | --- |
* | "Complete account setup" |
*
* @param {Completeaccountsetup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const completeaccountsetup2 = /** @type {((inputs?: Completeaccountsetup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Completeaccountsetup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_completeaccountsetup2(inputs)
	return de_completeaccountsetup2(inputs)
});
export { completeaccountsetup2 as "completeAccountSetup" }